'use strict';

function initHistoryBackForwardRefreshResults() {
    window.addEventListener('popstate', () => {
        window.location.reload();
    });
}

/**
 * response containing search-driven redirect, reloads url
 * @param {string} response - AJAX response HTML
 * @returns {boolean} true if a redirect was triggered
 */
function handleSearchRedirect(response) {
    const $redirectEl = $(response).filter('[data-search-redirect-url]');
    if (!$redirectEl.length) {
        return false;
    }
    const redirectUrl = $redirectEl.data('search-redirect-url');
    if (redirectUrl) {
        window.location.href = redirectUrl;
        return true;
    }
    return false;
}

/**
 * Restores the search query into the input field and reveals the reset button,
 * since the server-rendered value is always empty
 */
function restoreSearchFieldFromUrl() {
    var qParam = new URLSearchParams(window.location.search).get('q');
    if (qParam) {
        $('input.search-field').val(qParam);
        $('.site-search .reset-button').removeClass('d-none');
    }
}

/**
 * Carries the active sort rule over when the current query is re-submitted,
 * since the form only sends q and sorting (applied via pushState) would be lost
 */
function persistSortRuleOnSubmit() {
    $('form[name="simpleSearch"]').on('submit', function () {
        const $form = $(this);
        const params = new URLSearchParams(window.location.search);
        const srule = params.get('srule');
        const currentQuery = (params.get('q') || '').trim();
        const submittedQuery = ($form.find('input[name="q"]').val() || '').trim();

        $form.find('input[name="srule"]').remove();
        if (srule && currentQuery && currentQuery === submittedQuery) {
            $('<input>', { type: 'hidden', name: 'srule', value: srule }).appendTo($form);
        }
    });
}

module.exports = {
    initHistoryBackForwardRefreshResults: initHistoryBackForwardRefreshResults,
    handleSearchRedirect: handleSearchRedirect,
    restoreSearchFieldFromUrl: restoreSearchFieldFromUrl,
    persistSortRuleOnSubmit: persistSortRuleOnSubmit
};
